
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import QuoteListWidget from "./components/QuoteListWidget";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <QuoteListWidget />
    </BrowserRouter>
  );
}

export default App;
